import APNClipsModeration from "./pages/APNClipsModeration";
import APNClipsModerationAdmin from "./pages/APNClipsModerationAdmin.jsx";
// frontend/src/App.jsx
import { BrowserRouter, Routes, Route, Link, useParams, useNavigate, Navigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { MaintenanceAPI } from "./api";
import { UserProvider, UserContext } from "./context/UserContext";

import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AdminPending from "./pages/AdminPending";
import ChangePassword from "./pages/ChangePassword";
import AdminUsers from "./pages/AdminUsers";
import AdminPermissions from "./pages/AdminPermissions";
import useLayoutVars from "./hooks/useLayoutVars";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Sidebar from "./components/layout/Sidebar";
import OnlineUsersPanel from "./components/layout/OnlineUsersPanel";
import SidebarDrawer from "./components/layout/SidebarDrawer";
import Home from "./pages/Home";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminSidebarConfig from "./pages/AdminSidebarConfig";
import AdminRoles from "./pages/AdminRoles";
import AdminSocialPlatforms from "./pages/AdminSocialPlatforms.jsx";
import WeeklyPointsArchivePage from "./pages/WeeklyPointsArchive.jsx";
import SupportPlan from "./pages/SupportPlan.jsx";
import AdminBroadcast from "./pages/AdminBroadcast.jsx";
import AdminBadges from "./pages/AdminBadges.jsx";
import UserProfile from "./pages/UserProfile.jsx";
import UserPointsHistory from "./pages/UserPointsHistory.jsx";
import AdminPointsHistory from "./pages/AdminPointsHistory.jsx";
import AdminCronJobs from "./pages/AdminCronJobs.jsx";
import AdminLiveSettings from "./pages/AdminLiveSettings.jsx";
import TwitchBot from "./pages/TwitchBot.jsx";
import YouTubeBot from "./pages/YouTubeBot.jsx";
import AdminSfgTestImport from "./pages/AdminSfgTestImport.jsx";
import Lurker from "./pages/Lurker.jsx";
import Lurker2 from "./pages/Lurker2.jsx";
import LurkerRadar from "./pages/LurkerRadar.jsx";
import LurkerMember from "./pages/LurkerMember.jsx";
import AdminMaintenance from "./pages/AdminMaintenance.jsx";
import AdminServices from "./pages/AdminServices.jsx";
import AdminPackages from "./pages/AdminPackages.jsx";
import AdminDiscounts from "./pages/AdminDiscounts.jsx";
import AdminUploads from "./pages/AdminUploads.jsx";
import AdminLurkerLogs from "./pages/AdminLurkerLogs.jsx";
import AdminLurker2Assignments from "./pages/AdminLurker2Assignments.jsx";
import AdminNewsletter from "./pages/AdminNewsletter.jsx";
import Downloads from "./pages/Downloads.jsx";
import AdminDownloadsStats from "./pages/AdminDownloadsStats.jsx";
import Matchmaking from "./pages/Matchmaking.jsx";
import KnowledgeBase from "./pages/KnowledgeBase.jsx";
import AdminKnowledge from "./pages/AdminKnowledge.jsx";
import AdminSubscriptions from "./pages/AdminSubscriptions.jsx";
import ServersPage from "./pages/Servers.jsx";
// Neue Info-/Leistungs-Seiten
import AboutAPN from "./pages/AboutAPN.jsx";
import HowItWorksAPN from "./pages/HowItWorksAPN.jsx";
import TeamAPN from "./pages/TeamAPN.jsx";
import MentorProgram from "./pages/MentorProgram.jsx";
import MentorProgramService from "./pages/MentorProgramService.jsx";
import ServicesDetail from "./pages/ServicesDetail.jsx";
import B2B from "./pages/B2B.jsx";
import Communities from "./pages/Communities.jsx";
import Jobs from "./pages/Jobs.jsx";
import Partners from "./pages/Partners.jsx";
import EventsPage from "./pages/Events.jsx";
import EventDetail from "./pages/EventDetail.jsx";
import EventNew from "./pages/EventNew.jsx";
import EventEdit from "./pages/EventEdit.jsx";
import MyServices from "./pages/MyServices.jsx";
import MyImpressum from "./pages/MyImpressum.jsx";
import AdminShops from "./pages/AdminShops.jsx";
import Leaderboard from "./pages/Leaderboard.jsx";
import EditProfile from "./pages/EditProfile.jsx";
import Impressum from "./pages/Impressum.jsx";
import Datenschutz from "./pages/Datenschutz.jsx";
import Kontakt from "./pages/Kontakt.jsx";
import AGB from "./pages/AGB.jsx";
import NewsletterConfirm from "./pages/NewsletterConfirm.jsx";
import NewsletterUnsubscribe from "./pages/NewsletterUnsubscribe.jsx";
import ProfileDeletionConfirm from "./pages/ProfileDeletionConfirm.jsx";
import UserSearch from "./pages/UserSearch.jsx";
import PublicCatalog from "./pages/PublicCatalog.jsx";
import RequestOffer from "./pages/RequestOffer.jsx";
import Shops from "./pages/Shops.jsx";
import Members from "./pages/Members.jsx";
import Integrations from "./pages/Integrations.jsx";
import AuthCallback from "./pages/AuthCallback.jsx";

import MessagesInbox from "./pages/MessagesInbox.jsx";
import MessagesDetail from "./pages/MessagesDetail.jsx";
import Chat from "./pages/Chat.jsx";
import CommunityChat from "./pages/CommunityChat.jsx";
import ErrorBoundary from "./components/ErrorBoundary";
import DiscordWebhook from "./pages/DiscordWebhook.jsx";
import SocialFeedDebug from "./pages/SocialFeedDebug.jsx";
import NewsFeed from "./pages/NewsFeed.jsx";
import KreativStudio from "./pages/KreativStudio.jsx";
import ReferralOverview from "./pages/ReferralOverview.jsx";
import SeasonalEvents from "./pages/SeasonalEvents.jsx";
import FeatureRequests from "./pages/FeatureRequests.jsx";
import MentorAssignments from "./pages/MentorAssignments.jsx";
import MentorMyTrainees from "./pages/MentorMyTrainees.jsx";
import AdminMentorMonitoring from "./pages/AdminMentorMonitoring.jsx";
import CommunityMap from "./pages/CommunityMap.jsx";
import CommunityCalendar from "./pages/CommunityCalendar.jsx";
import EasterEggHuntOverlay from "./components/EasterEggHuntOverlay.jsx";
import PunkteSpiele from "./pages/PunkteSpiele.jsx";
import Gluecksrad from "./pages/Gluecksrad.jsx";
import EinarmigerBandit from "./pages/EinarmigerBandit.jsx";
import Greifautomat from "./pages/Greifautomat.jsx";
import APNClips from "./pages/APNClips.jsx";
import APNClipsSubmit from "./pages/APNClipsSubmit.jsx";
import APNClipsVoting from "./pages/APNClipsVoting.jsx";
import APNClipsTopMonth from "./pages/APNClipsTopMonth.jsx";
import APNClipsArchive from "./pages/APNClipsArchive.jsx";

export default function App() {
    // useLayoutVars();
  const [maintEnabled, setMaintEnabled] = useState(null);
    useEffect(() => {
    const footer = document.querySelector("footer.apn-footer-modern");
    const setVar = () => {
      const h = footer?.offsetHeight || 72;
      document.documentElement.style.setProperty("--footer-h", `${h}px`);
    };
    setVar();
    const ro = new ResizeObserver(setVar);
    if (footer) ro.observe(footer);
    window.addEventListener("resize", setVar);
    return () => { ro.disconnect(); window.removeEventListener("resize", setVar); };
  }, []);
  // Global maintenance status polling for guests (no WS)
  useEffect(() => {
    let mounted = true;
    let prev = null;
    const check = async () => {
      try {
        const s = await MaintenanceAPI.status();
        if (!mounted) return;
        const flag = !!s?.enabled;
        setMaintEnabled(flag);
        if (prev === null) prev = flag;
        else if (prev !== flag) {
          window.location.reload();
        }
      } catch {}
    };
    const id = setInterval(check, 15000);
    // initial
    check();
    return () => { mounted = false; clearInterval(id); };
  }, []);
  return (
    <UserProvider>
      <div className="app-shell" style={{width:'100%',margin:0,padding:0}}>
        {/* Hide header for guests during maintenance */}
        {(!maintEnabled || maintEnabled === false) ? <Header /> : (
          // maintEnabled === true
          <HeaderVisibilityGuard />
        )}
        <AppContent />
        <Footer />
      </div>
    </UserProvider>
  );
}

// Separater Content-Block, damit useContext *innerhalb* des Providers läuft
function AppContent() {
  const { user } = useContext(UserContext);
  return (
    <div className={`app-mainrow ${user ? "with-sidebar" : ""}`} style={{width:'100%',margin:0,padding:0}}>
      {/* linke Sidebar nur eingeloggt */}
      {user && <Sidebar />}
      <main id="main" className="app-content" style={{width:'100%',margin:0,padding:0}}>
  <Routes>
            <Route path="/me/points" element={<ProtectedRoute><UserPointsHistory /></ProtectedRoute>} />
            <Route path="/admin/points-history" element={<ProtectedRoute roles={["moderator","admin"]}><AdminPointsHistory /></ProtectedRoute>} />
            <Route path="/admin/cronjobs" element={<ProtectedRoute role="admin"><AdminCronJobs /></ProtectedRoute>} />
            <Route path="/admin/maintenance" element={<ProtectedRoute role="admin"><AdminMaintenance /></ProtectedRoute>} />
            <Route path="/admin/live-settings" element={<ProtectedRoute role="admin"><AdminLiveSettings /></ProtectedRoute>} />
            <Route path="/twitch-bot" element={<ProtectedRoute role="admin"><TwitchBot /></ProtectedRoute>} />
            <Route path="/youtube-bot" element={<ProtectedRoute role="admin"><YouTubeBot /></ProtectedRoute>} />
            <Route path="/admin/sfg-test-import" element={<ProtectedRoute role="admin"><AdminSfgTestImport /></ProtectedRoute>} />
             <Route path="/lurker" element={<ProtectedRoute><Lurker /></ProtectedRoute>} />
             <Route path="/lurker2" element={<ProtectedRoute><Lurker2 /></ProtectedRoute>} />
             <Route path="/lurker2/radar" element={<ProtectedRoute><LurkerRadar /></ProtectedRoute>} />
             <Route path="/lurker/:username" element={<ProtectedRoute><LurkerMember /></ProtectedRoute>} />
            <Route path="/admin/services" element={<ProtectedRoute role="admin"><AdminServices /></ProtectedRoute>} />
            <Route path="/admin/packages" element={<ProtectedRoute role="admin"><AdminPackages /></ProtectedRoute>} />
            <Route path="/admin/discounts" element={<ProtectedRoute role="admin"><AdminDiscounts /></ProtectedRoute>} />
            <Route path="/admin/discounts" element={<ProtectedRoute role="admin"><AdminDiscounts /></ProtectedRoute>} />
            <Route path="/admin/uploads" element={<ProtectedRoute role="admin"><AdminUploads /></ProtectedRoute>} />
            <Route path="/admin/uploads/categories" element={<ProtectedRoute role="admin"><AdminUploads /></ProtectedRoute>} />
            <Route path="/admin/uploads/stats" element={<ProtectedRoute role="admin"><AdminDownloadsStats /></ProtectedRoute>} />
            <Route path="/admin/lurker-logs" element={<ProtectedRoute roles={["admin","owner"]}><AdminLurkerLogs /></ProtectedRoute>} />
            <Route path="/admin/lurker2-assignments" element={<ProtectedRoute roles={["admin","owner"]}><AdminLurker2Assignments /></ProtectedRoute>} />
            <Route path="/admin/newsletter" element={<ProtectedRoute role="admin"><AdminNewsletter /></ProtectedRoute>} />
            <Route path="/admin/subscriptions" element={<ProtectedRoute role="admin"><AdminSubscriptions /></ProtectedRoute>} />
          <Route path="/admin/badges" element={<ProtectedRoute role="admin"><AdminBadges /></ProtectedRoute>} />
          <Route path="/admin/roles" element={<ProtectedRoute role="admin"><AdminRoles /></ProtectedRoute>} />
          <Route path="/admin/sidebar-config" element={<ProtectedRoute role="admin"><AdminSidebarConfig /></ProtectedRoute>} />
            <Route path="/supportplan" element={<ProtectedRoute><SupportPlan /></ProtectedRoute>} />
          <Route path="/admin/social-platforms" element={<ProtectedRoute role="admin"><AdminSocialPlatforms /></ProtectedRoute>} />
            <Route path="/weekly-points-archive" element={<ProtectedRoute roles={["admin","owner","moderator"]}><WeeklyPointsArchivePage /></ProtectedRoute>} />
          <Route path="/admin/broadcast" element={<ProtectedRoute roles={["admin","moderator"]}><AdminBroadcast /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          {/* Public newsletter routes to work even during maintenance; include wildcard to catch proxy-appended URLs */}
          <Route path="/newsletter/confirm/*" element={<NewsletterConfirm />} />
          <Route path="/newsletter/unsubscribe/*" element={<NewsletterUnsubscribe />} />
          <Route path="/profile/delete/confirm/*" element={<ProfileDeletionConfirm />} />
          <Route path="/admin/pending" element={<ProtectedRoute roles={["admin","moderator"]}><AdminPending /></ProtectedRoute>} />
          <Route path="/account/password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute role="admin"><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/permissions" element={<ProtectedRoute role="admin"><AdminPermissions /></ProtectedRoute>} />
          <Route path="/admin/referrals" element={<ProtectedRoute roles={["admin","moderator"]}><ReferralOverview /></ProtectedRoute>} />
          <Route path="/profile" element={<EditProfileWrapper />} />
          <Route path="/u/:id" element={<UserProfileWrapper />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGBGuard />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/angebote" element={<PublicCatalog />} />
          <Route path="/angebot-anfordern" element={<RequestOffer />} />
          <Route path="/shops" element={<Shops />} />
          <Route path="/mitglieder" element={<Members />} />
          <Route path="/search" element={<ProtectedRoute><UserSearch /></ProtectedRoute>} />
          <Route path="/downloads" element={<ProtectedRoute><Downloads /></ProtectedRoute>} />
          <Route path="/matchmaking" element={<ProtectedRoute><Matchmaking /></ProtectedRoute>} />
          <Route path="/knowledge" element={<ProtectedRoute><KnowledgeBase /></ProtectedRoute>} />
          <Route path="/feature-requests" element={<ProtectedRoute><FeatureRequests /></ProtectedRoute>} />
          <Route path="/punkte-spiele" element={<ProtectedRoute><PunkteSpiele /></ProtectedRoute>} />
          <Route path="/punkte-spiele/gluecksrad" element={<ProtectedRoute><Gluecksrad /></ProtectedRoute>} />
          <Route path="/punkte-spiele/einarmiger-bandit" element={<ProtectedRoute><EinarmigerBandit /></ProtectedRoute>} />
          <Route path="/punkte-spiele/greifautomat" element={<ProtectedRoute><Greifautomat /></ProtectedRoute>} />
          <Route path="/gluecksrad" element={<ProtectedRoute><Navigate to="/punkte-spiele/gluecksrad" replace /></ProtectedRoute>} />
          <Route path="/apn-clips" element={<ProtectedRoute><APNClips /></ProtectedRoute>} />
          <Route path="/apn-clips/submit" element={<ProtectedRoute><APNClipsSubmit /></ProtectedRoute>} />
          <Route path="/apn-clips/voting" element={<ProtectedRoute><APNClipsVoting /></ProtectedRoute>} />
          <Route path="/apn-clips/top" element={<ProtectedRoute><APNClipsTopMonth /></ProtectedRoute>} />
          <Route path="/apn-clips/archive" element={<ProtectedRoute><APNClipsArchive /></ProtectedRoute>} />
           <Route path="/apn-clips/moderation" element={<ProtectedRoute roles={["admin","moderator"]}><APNClipsModeration /></ProtectedRoute>} />
          <Route path="/apn-clips/moderation/admin" element={<ProtectedRoute role="admin"><APNClipsModerationAdmin /></ProtectedRoute>} />
          <Route path="/community-map" element={<ProtectedRoute><CommunityMap /></ProtectedRoute>} />
          <Route path="/community-calendar" element={<ProtectedRoute><CommunityCalendar /></ProtectedRoute>} />
          <Route path="/servers" element={<ServersPage />} />
          {/* Neue öffentliche Info-/Leistungs-Seiten */}
          <Route path="/ueber-ap-network" element={<AboutAPN />} />
          <Route path="/wie-funktioniert-ap-n" element={<HowItWorksAPN />} />
          <Route path="/team-ap-n" element={<TeamAPN />} />
          <Route path="/mentoren-programm" element={<MentorProgram />} />
          <Route path="/mentoren-programm-service" element={<MentorProgramService />} />
          <Route path="/leistungen-im-detail" element={<ServicesDetail />} />
          <Route path="/firmen-und-vereine-b2b" element={<B2B />} />
          <Route path="/fuer-communitys" element={<Communities />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/unsere-partner" element={<Partners />} />
          <Route path="/events" element={<ProtectedRoute><EventsPage /></ProtectedRoute>} />
          <Route path="/events/new" element={<ProtectedRoute permission="events.manage"><EventNew /></ProtectedRoute>} />
          <Route path="/events/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
          <Route path="/events/:id/edit" element={<ProtectedRoute><EventEdit /></ProtectedRoute>} />
          <Route path="/admin/knowledge" element={<ProtectedRoute roles={["admin","moderator"]}><AdminKnowledge /></ProtectedRoute>} />
          <Route path="/admin/shops" element={<ProtectedRoute role="admin"><AdminShops /></ProtectedRoute>} />
          <Route path="/admin/mentor-monitoring" element={<ProtectedRoute role="admin"><AdminMentorMonitoring /></ProtectedRoute>} />
          <Route path="/admin/seasonal-events" element={<ProtectedRoute roles={["moderator","admin","owner"]}><SeasonalEvents /></ProtectedRoute>} />
          <Route path="/mentor-assignments" element={<ProtectedRoute roles={["moderator","admin","owner"]}><MentorAssignments /></ProtectedRoute>} />
          <Route path="/mentor-my-trainees" element={<ProtectedRoute roles={["mentor","moderator","admin","owner"]}><MentorMyTrainees /></ProtectedRoute>} />
          <Route path="/me/services" element={<ProtectedRoute><MyServices /></ProtectedRoute>} />
          <Route path="/me/impressum" element={<ProtectedRoute><MyImpressum /></ProtectedRoute>} />
          <Route path="/integrations" element={<ProtectedRoute><Integrations /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><MessagesInbox /></ProtectedRoute>} />
          <Route path="/messages/:id" element={<ProtectedRoute><MessagesDetail /></ProtectedRoute>} />
          <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
          <Route path="/community-chat" element={<ProtectedRoute><ErrorBoundary><CommunityChat /></ErrorBoundary></ProtectedRoute>} />
          <Route path="/discord-webhook" element={<ProtectedRoute><DiscordWebhook /></ProtectedRoute>} />
          <Route path="/news" element={<ProtectedRoute><NewsFeed /></ProtectedRoute>} />
          <Route path="/debug/social-feed" element={<ProtectedRoute roles={["admin","owner"]}><SocialFeedDebug /></ProtectedRoute>} />
          <Route path="/kreativ-studio" element={<ProtectedRoute><KreativStudio /></ProtectedRoute>} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="*" element={<NotFound />} />
        </Routes>

        <EasterEggHuntOverlay />
      </main>
      {/* rechtes, ausklappbares Online-Panel nur eingeloggt */}
      {user && <OnlineUsersPanel />}
      {/* Mobile sidebar toggle (shown under 1320px) */}
      {user && <SidebarDrawer />}
    </div>
  );
}

// Helper to only render Header when a user is logged in (used if maintenance is active)
function HeaderVisibilityGuard() {
  const { user } = useContext(UserContext);
  if (!user) return null;
  return <Header />;
}

// Wrapper für Profilseiten (außerhalb von App und AppContent)


function EditProfileWrapper() {
  const { user } = useContext(UserContext);
  return <EditProfile user={user || {}} />;
}

// Wrapper für Profilseiten (außerhalb von App und AppContent)
function UserProfileWrapper() {
  const { id } = useParams();
  return <UserProfile userId={id} />;
}

function NotFound() {
  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginTop: 0 }}>Seite nicht gefunden</h2>
      <p>Die angeforderte Seite existiert nicht oder ist nicht mehr verfügbar.</p>
    </div>
  );
}

// Block AGB page during maintenance for all users
function AGBGuard() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const s = await MaintenanceAPI.status();
        if (!mounted) return;
        const maint = !!s?.enabled;
        if (maint && !user) {
          setAllowed(false);
          navigate("/", { replace: true });
        } else {
          setAllowed(true);
        }
      } catch {
        // On error, allow to avoid accidental blocking
        setAllowed(true);
      } finally {
        if (mounted) setChecking(false);
      }
    })();
    return () => { mounted = false; };
  }, [user, navigate]);

  if (checking) return null;
  return allowed ? <AGB /> : null;
}


